"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// importing external style
// import React, { useState } from 'react';
// import React, { useState, useRef } from 'react';
var styles_1 = require("../../styles");
var react_1 = __importStar(require("react"));
var retell_client_js_sdk_1 = require("retell-client-js-sdk");
require("../../../../src/app.css");
var config_1 = __importDefault(require("../../../constants/config"));
var agentId = "agent_b1a90afc73130fd4ff0fbda22a";
var retellWebClient = new retell_client_js_sdk_1.RetellWebClient();
function ModalWindow(props) {
    var _this = this;
    var _a = (0, react_1.useState)(null), micStream = _a[0], setMicStream = _a[1];
    var _b = (0, react_1.useState)(null), audioMotion = _b[0], setAudioMotion = _b[1];
    var _c = (0, react_1.useState)(false), isCalling = _c[0], setIsCalling = _c[1];
    var _d = (0, react_1.useState)(false), startingCall = _d[0], setstartingCall = _d[1];
    var _e = (0, react_1.useState)(false), showPopup = _e[0], setsshowPopup = _e[1];
    var _f = (0, react_1.useState)([]), chatData = _f[0], setChatData = _f[1];
    var chatContainerRef = (0, react_1.useRef)(null);
    var _g = (0, react_1.useState)(null), micAccess = _g[0], setMicAccess = _g[1];
    // Initialize the SDK
    var canvasRef = (0, react_1.useRef)(null);
    var _h = (0, react_1.useState)(null), audioContext = _h[0], setAudioContext = _h[1];
    var _j = (0, react_1.useState)(null), analyser = _j[0], setAnalyser = _j[1];
    var _k = (0, react_1.useState)(0), bufferLength = _k[0], setBufferLength = _k[1];
    var _l = (0, react_1.useState)(null), dataArray = _l[0], setDataArray = _l[1];
    (0, react_1.useEffect)(function () {
        try {
            var handleUpdate_1 = function (update) {
                if (update.transcript && update.transcript.length > 0) {
                    var lastMessage = update.transcript[update.transcript.length - 1];
                    var newContent_1 = lastMessage.content || ""; // Ensure content exists
                    var role_1 = lastMessage.role;
                    console.log(lastMessage);
                    setChatData(function (prev) {
                        var lastBubble = prev[prev.length - 1];
                        // If the last bubble is from the same speaker, replace its content
                        if (lastBubble && lastBubble.role === role_1) {
                            return __spreadArray(__spreadArray([], prev.slice(0, -1), true), [
                                __assign(__assign({}, lastBubble), { content: newContent_1 }),
                            ], false);
                        }
                        // If speaker changes, add a new bubble
                        return __spreadArray(__spreadArray([], prev, true), [
                            { role: role_1, content: newContent_1 },
                        ], false);
                    });
                }
            };
            retellWebClient.on("call_started", function () {
                console.log("call started By Web Call");
            });
            retellWebClient.on("call_ended", function () {
                try {
                    console.log("call_ended");
                    setIsCalling(false);
                    props.setVisible(false);
                }
                catch (e) {
                    console.log("call_ended");
                    props.setVisible(false);
                }
            });
            // When agent starts talking for the utterance
            // useful for animation
            retellWebClient.on("agent_start_talking", function (op) {
                console.log("agent_start_talking");
            });
            // When agent is done talking for the utterance
            // useful for animation
            retellWebClient.on("agent_stop_talking", function () {
                console.log("agent_stop_talking");
            });
            // Real time pcm audio bytes being played back, in format of Float32Array
            // only available when emitRawAudioSamples is true
            retellWebClient.on("audio", function (audio) {
                // console.log("audio", audio)
                //byteLength
                // setDataArray(new Float32Array(audio)); 
                // draw();
                // handleCallAudio(audio);
            });
            // Update message such as transcript
            // You can get transcrit with update.transcript
            // Please note that transcript only contains last 5 sentences to avoid the payload being too large
            // retellWebClient.on("update", (update) => {
            //     console.log(update,'updates');
            //     console.log(update.transcript);
            // });
            retellWebClient.on("update", handleUpdate_1);
            // update.transcript
            retellWebClient.on("metadata", function (metadata) {
                // console.log(metadata);
            });
            retellWebClient.on("error", function (error) {
                console.log("An error occurred:", error);
                // Stop the call
                retellWebClient.stopCall();
            });
            return function () {
                // Cleanup listeners
                retellWebClient.off("update", handleUpdate_1);
            };
        }
        catch (e) {
            console.log(e);
        }
    }, []);
    var handleMicToggle = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (vis) {
            if (vis === void 0) { vis = false; }
            return __generator(this, function (_a) {
                try {
                    console.log(vis, 'vis');
                    // try {
                    //     const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                    //     alert('123')
                    //     setMicAccess("Microphone access granted.");
                    //     // stream.getTracks().forEach(track => track.stop()); // Stop mic access after check
                    //   } catch (error: any) {
                    //     if (error.name === "NotAllowedError" || error.name === "PermissionDeniedError") {
                    //       setMicAccess("Microphone access denied. Please allow access in browser settings.");
                    //     } else if (error.name === "NotFoundError" || error.name === "DevicesNotFoundError") {
                    //       setMicAccess("No microphone found. Please connect a microphone.");
                    //     } else {
                    //       setMicAccess("An error occurred while accessing the microphone.");
                    //     }
                    //   }
                    if (vis) {
                        if (navigator.mediaDevices) {
                            navigator.mediaDevices
                                .getUserMedia({ audio: true, video: false })
                                .then(function (stream) {
                                setMicAccess("Microphone access granted.");
                                // Create MediaStreamSource from microphone input
                                var micSource = audioMotion.audioCtx.createMediaStreamSource(stream);
                                // Connect microphone stream to AudioMotionAnalyzer
                                audioMotion.connectInput(micSource);
                                // Mute output to prevent feedback loop
                                audioMotion.volume = 0;
                                // Save the stream
                                setMicStream(stream);
                            }).catch(function (error) {
                                if (error.name === "NotAllowedError" || error.name === "PermissionDeniedError") {
                                    setMicAccess("Microphone access denied. Please allow access in browser settings.");
                                }
                                else if (error.name === "NotFoundError" || error.name === "DevicesNotFoundError") {
                                    setMicAccess("No microphone found. Please connect a microphone.");
                                }
                                else {
                                    setMicAccess("An error occurred while accessing the microphone.");
                                }
                            });
                        }
                        else {
                            alert('User mediaDevices not available');
                        }
                    }
                    else {
                        // Disconnect the microphone stream
                        if (micStream) {
                            audioMotion.disconnectInput(micStream, true);
                            setMicStream(null);
                        }
                    }
                }
                catch (console) {
                    console.log("Error in handleMicToggle:", console);
                }
                return [2 /*return*/];
            });
        });
    };
    var toggleConversation = function (val) { return __awaiter(_this, void 0, void 0, function () {
        var registerCallResponse, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    if (!(isCalling && val == false)) return [3 /*break*/, 1];
                    retellWebClient.stopCall();
                    return [3 /*break*/, 3];
                case 1:
                    if (!val) return [3 /*break*/, 3];
                    //    alert('starting call')
                    // if(micAccess == "Microphone access granted."){
                    console.log(config_1.default.agentId);
                    return [4 /*yield*/, registerCall(config_1.default.agentId)];
                case 2:
                    registerCallResponse = _a.sent();
                    if (registerCallResponse.access_token) {
                        retellWebClient.startCall({
                            accessToken: registerCallResponse.access_token,
                            emitRawAudioSamples: true,
                            sampleRate: 24000,
                        }).catch(function (e) { return console.log(e, 'message'); });
                        setIsCalling(true); // Update button to "Stop" when conversation starts
                        setstartingCall(false);
                    }
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    console.log(e_1, 'message two');
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    function registerCall(agentId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        setstartingCall(true);
                        return [4 /*yield*/, fetch("https://api.retellai.com/v2/create-web-call", {
                                method: "POST",
                                headers: {
                                    'Authorization': 'Bearer 1b07e2d1-c19f-44de-a638-303e755e1477', // Replace with your actual Bearer token
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    agent_id: agentId, // Pass the agentId as agent_id
                                    // You can optionally add metadata and retell_llm_dynamic_variables here if needed
                                    metadata: { sourceId: config_1.default.sourceId },
                                    retell_llm_dynamic_variables: { sourceId: config_1.default.sourceId }
                                }),
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            console.log("Error: ".concat(response.status));
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, data];
                    case 3:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    // Scroll to the bottom whenever chatData updates
    (0, react_1.useEffect)(function () {
        if (props.visible) {
            // initAudio()
            // alert(props.visible)
            toggleConversation(props.visible);
            // handleMicToggle(props.visible);
            // Turn on the microphone when the modal becomes visible
        }
        else {
            setChatData([]);
            toggleConversation(false);
            // handleMicToggle(false);
        }
    }, [props.visible]);
    (0, react_1.useEffect)(function () {
        if (chatContainerRef.current && props.visible) {
            chatContainerRef.current.scrollTo({
                top: chatContainerRef.current.scrollHeight,
                behavior: "smooth", // Use smooth scrolling
            });
        }
    }, [chatData]);
    (0, react_1.useEffect)(function () {
        if (audioContext && analyser && canvasRef.current) {
            draw();
        }
    }, [audioContext, analyser, bufferLength, dataArray]);
    var initAudio = function () {
        navigator.mediaDevices.getUserMedia({ audio: true })
            .then(function (stream) {
            var audioCtx = new (window.AudioContext || window.webkitAudioContext)();
            var analyserNode = audioCtx.createAnalyser();
            var source = audioCtx.createMediaStreamSource(stream);
            source.connect(analyserNode);
            analyserNode.fftSize = 512;
            var bufferLen = analyserNode.frequencyBinCount;
            var dataArr = new Float32Array(bufferLen);
            setAudioContext(audioCtx);
            setAnalyser(analyserNode);
            setBufferLength(bufferLen);
            setDataArray(dataArr);
        })
            .catch(function (err) {
            console.error('Error accessing microphone:', err);
        });
    };
    var draw = function () {
        if (dataArray) {
            var canvas = canvasRef.current;
            var ctx = canvas.getContext('2d');
            if (ctx) {
                analyser.getFloatTimeDomainData(dataArray);
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                var centerX = canvas.width / 2;
                var centerY = canvas.height / 2;
                var baseRadius = canvas.width * 0.375; // Make the base radius 37.5% of the canvas width
                var distortionFactor = 0;
                for (var i = 0; i < bufferLength; i++) {
                    distortionFactor += Math.abs(dataArray[i]);
                }
                distortionFactor /= bufferLength;
                var dynamicFactor = distortionFactor * 200;
                ctx.lineWidth = 2;
                ctx.strokeStyle = '#00e0ff';
                ctx.beginPath();
                for (var i = 0; i < bufferLength; i++) {
                    var angle = (i / bufferLength) * Math.PI * 2;
                    var distance = Math.sin((angle + performance.now() * 0.003) * 0.5) * dynamicFactor;
                    var dynamicRadius = baseRadius + Math.sin(angle * 3) * dynamicFactor;
                    var x = centerX + Math.cos(angle) * dynamicRadius + distance;
                    var y = centerY + Math.sin(angle) * dynamicRadius + distance;
                    if (i === 0) {
                        ctx.moveTo(x, y);
                    }
                    else {
                        ctx.lineTo(x, y);
                    }
                }
                ctx.closePath();
                ctx.stroke();
                requestAnimationFrame(draw);
            }
        }
    };
    return (react_1.default.createElement("div", { style: __assign(__assign(__assign({}, styles_1.styles.modalWindow), { display: props.visible ? "none" : "none", opacity: props.visible ? "1" : "0", transition: "opacity 0.3s ease" }), { opacity: props.visible ? "1" : "0" }) },
        react_1.default.createElement("div", { className: "chat-container", ref: chatContainerRef, style: {
                height: "56vh", // Adjust height based on the viewport
                width: "100%",
                overflowY: "auto",
                background: "#333",
                padding: "1rem",
                borderRadius: "10px",
                display: startingCall && !isCalling ? "flex" : "block", // Center loading icon
                justifyContent: "center", // Center loading icon horizontally
                alignItems: "center", // Center loading icon vertically
            } }, startingCall && !isCalling ? (react_1.default.createElement("div", { className: "loading-icon" },
            react_1.default.createElement("div", { className: "spinner" }),
            " ",
            react_1.default.createElement("p", { style: { color: "#fff", marginTop: "1rem" } }, "Connecting..."))) : (
        // Render chat bubbles when the call is connected
        chatData.map(function (message, index) { return (react_1.default.createElement("div", { key: index, className: "chat-bubble ".concat(message.role === "agent" ? "agent" : "user") }, message.content)); })))));
}
exports.default = ModalWindow;
